import styled from 'styled-components';

import { DialogAudio, RTC } from './useRTC';
import { useSelector } from 'react-redux';
import { NodeTrace, State } from '@store/index';
import { TabContext, TabPanel } from '@mui/lab';
import { Alert, Stack } from '@mui/material';
import { WorkflowTrace } from '@common/Node/CompletionChatbot/WorkflowTrace';
import { SoftphoneState } from './SoftphoneState';
import { useParams } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  flex-direction: column;

  & .MuiTabPanel-root {
    padding: 0;
  }
`;

export const CallTimer = styled.span`
  color: #8a8f97;
  font-size: 1.8ch;
  border-radius: 0.5rem;
  margin-bottom: 2rem;
  margin-top: 0.5rem;
  font-weight: 500;
`;

interface Props {
  rtc: RTC;
  seconds: number;
  minutes: number;
}

export const Softphone: React.FC<Props> = ({ rtc, seconds, minutes }) => {
  const { workflow_id } = useParams();

  const call = rtc.call;
  const trace = useSelector((state: State) => state.tabs.active.run);
  const commands = useSelector((state: State) => state.tabs.active.commands);
  const tracesWithoutModules = trace.traces.filter(
    (trace) => trace?.metadata?.workflow_id === workflow_id || !trace?.metadata?.workflow_id
  );
  const hideSoftphone =
    !call || (rtc.state.isHungup && trace.traces?.every((trace) => trace.metadata?.status !== 'processing'));

  return (
    <Container>
      <TabContext value='1'>
        {/* <SoftphoneTabs setTab={setTab} /> */}
        {!hideSoftphone && <SoftphoneState rtc={rtc} seconds={seconds} minutes={minutes} />}
        <TabPanel value='1'>
          {(trace?.running || trace?.id) && trace.traces.length === 0 ? (
            <Stack padding='16px 20px'>
              <Alert severity='info'>The workflow is starting. You will see events show here shortly.</Alert>
            </Stack>
          ) : (
            <Stack padding='16px 20px' spacing={1.5}>
              {tracesWithoutModules.map((item: NodeTrace, index) => {
                const command = commands.find((command) => command.node.id === item?.metadata?.node_id);
                const isModNode = command?.config?.command_id === 'node.module';

                const moduleTraces = isModNode
                  ? trace.traces.filter((trace) => trace?.metadata?.workflow_id === command?.state?.moduleId)
                  : [];

                return <WorkflowTrace key={index} trace={item} moduleTraces={moduleTraces} />;
              })}
            </Stack>
          )}
        </TabPanel>
      </TabContext>
      {call && <DialogAudio stream={call.remoteStream} />}
    </Container>
  );
};
